export const colors = {
	hoverbg: '#F5F1EF',
	axis: {
		line: '#DACFD5',
		tick: '#6C6066',
		xLabel: '#6C6066',
		yLabel: '#6C6066',
	},
}
